import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

import { App } from '@/App';
import '@/index.css';

/*
  현장에서 손에 들고 쓰는 화면이라 통신이 자주 끊긴다. 창을 다시 볼 때마다 다시 부르지 않고,
  실패는 두 번까지만 다시 시도한다 — 끊긴 망에서 무한히 두드리면 배터리만 먹는다.
*/
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 2,
      staleTime: 30_000,
    },
  },
});

const container = document.getElementById('root');
if (container === null) throw new Error('#root 를 찾지 못했다.');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
